import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import { TProvider, TServiceType } from '../types'
import { AvailabilityIcons } from './availability-icons'

interface IProvidersCardListProps {
  type: TServiceType
}

export function ProvidersCardList({ type }: IProvidersCardListProps) {
  const t = useTranslations('Services')

  // Show the label even without a logo when rows need telling apart.
  const showProviderName = (provider: TProvider) =>
    Boolean(provider.img) ||
    Boolean(type.providerColumnTitle) ||
    type.providers.length > 1

  return (
    <div>
      {type.providers.map((provider) => (
        <div
          className={cn(
            'flex flex-col border-dashed border-gray-100 py-4 not-first:my-8 not-last:border-b-2 not-last:pb-10',
            showProviderName(provider) ? 'px-3' : 'pt-0'
          )}
          key={provider.name}
        >
          {showProviderName(provider) && (
            <div className="flex items-center gap-2">
              {provider.img && (
                <Image
                  src={provider.img}
                  alt={t(provider.name)}
                  width={40}
                  height={40}
                />
              )}

              <span className="text-body-3 text-primary-600">
                {t(provider.name)}
              </span>
            </div>
          )}
          <hr
            className={cn(
              'my-4 h-0.5 border-0 bg-gray-100',
              showProviderName(provider) ? 'my-4' : 'mt-0 mb-10'
            )}
          />
          <div className="text-body-3 space-y-1">
            <div className="text-primary-600 flex justify-between">
              <span>{t('categories.commission.title')}</span>
              <span className="inline-block max-w-37.5 text-right">
                {provider.commission.map((commission) => (
                  <span key={commission}>{t(commission)}</span>
                ))}
              </span>
            </div>
            {provider.maxSum && (
              <div className="text-primary-400 flex justify-between">
                <span>{t('categories.maxSum.title')}</span>
                <span>
                  {provider.maxSum} ֏{provider.maxSumNote}
                </span>
              </div>
            )}
            <div className="text-primary-400 flex justify-between">
              <span>{t('categories.transferPeriod.title')}</span>
              <span>{t(provider.period)}</span>
            </div>
            <div className="text-primary-400 flex justify-between">
              <span>{t('categories.available.title')}</span>

              <div className="flex items-center gap-1">
                <AvailabilityIcons available={provider.available} size="sm" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
